import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { CommunityReviews } from './components/Communities/CommunityReviews';
import { CommunityCatalogs } from './components/Communities/CommunityCatalogs';
import { LocalizeProvider } from 'react-localize-redux';
import LocalizationInitializer from './components/LocalizationInitializer';
import UserPreferences from './components/UserPreferences';
import WizardHome from './components/Wizard/WizardHome';
import './NewLook.css';
import './crm.css';
import './assets/fontastic.css';
import './general.css';
import './communities.css';

export default class App extends Component {
	displayName = App.name;

	render() {
		return (
			<LocalizeProvider>
				<LocalizationInitializer>
					<UserPreferences>
						<Layout>
							<Route exact path="/" component={Home} />
							<Route
								path="/community/:communityId/reviews/:reviewsCreatedDateMaxDaysBack"
								component={CommunityReviews}
							/>
							<Route
								path="/community/:communityId/catalogs/:catalogsCreatedDateMaxDaysBack"
								component={CommunityCatalogs}
							/>
							<Route
								exact
								path="/community/wizard"
								component={WizardHome}
							/>
						</Layout>
					</UserPreferences>
				</LocalizationInitializer>
			</LocalizeProvider>
		);
	}
}
